import { CompCircularProgressCore } from '../core/circular-progress/comp'

export const CompCircularProgress = CompCircularProgressCore
